import React, { useState, useEffect } from "react";
import { Form, Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import {
  AlertMessage,
  FormInputControl,
  FormInputGroup,
  FormSelectControl,
} from "../common";
import codeActivationService from "../../../service/codeActivation/CodeActive";
import style from "./codeactive.module.scss";

// Function to get the current month in two-digit format
const getCurrentMonth = () => {
  const date = new Date();
  const day = ('0' + date.getDate()).slice(-2); // Get current day, ensure two digits
  const month = ('0' + (date.getMonth() + 1)).slice(-2); // Get current month, ensure two digits
  const year = date.getFullYear(); // Get current year

  return `${day}-${month}-${year}`;
};


function ModalForms({ balance, transFee, submitSuccess, handleClose }) {
  const { currentTheme } = useSelector((state) => state.Theme);
  const service = new codeActivationService();
  const { t } = useTranslation();
  const Currency = useSelector((state) => state.curr);
  const [state, setState] = useState({
    Notes: "",
    IsError: false,
    notifyMessage: "",
    notyfiType: "",
    header: "Error!",
    activationCode: "",
    securityCode: "",
    month: getCurrentMonth(),
    validated: false,
    FormError: {
      activationCode: "",
      securityCode: "",
      month: "",
    },
    loader: false,
  });

  const [currentMonth, setCurrentMonth] = useState('');

  const {
    FormError,
    IsError,
    notifyMessage,
    notyfiType,
    header,
  } = state;

  // Binding the text changes
  const textChangeHandler = (e) => {
    e.preventDefault();
    const { name, value } = e.target;
    setState((prev) => ({
      ...prev,
      validated: false,
      [name]: value,
      FormError: {
        ...prev.FormError,
        [name]: "",
      },
    }));
  };

  // Notified closed handler
  const notifyDissmissed = () => {
    setState((prev) => ({
      ...prev,
      IsError: false,
      notifyMessage: "",
    }));
    if (notyfiType === "success") {
      handleClose();
    }
  };

  // Submit form handler
  const submitForm = (e) => {
    e.preventDefault();
    let valid = true;
    const validActivationCode = validation("activationCode");
    const validSecurityCode = validation("securityCode");
    const validMonth = validation("month");
    if (!validActivationCode || !validSecurityCode || !validMonth) {
      valid = false;
    }
    if (valid) {
      // submit the form
    } else {
      setState((prev) => ({
        ...prev,
        IsError: true,
        notifyMessage: "Please fill in all required fields",
        notyfiType: "danger",
        header: "Error!",
        loader: false,
      }));
    }
    if (validActivationCode && validSecurityCode && validMonth) {
      let formData = {
        securityCode: state.securityCode,
        accessCode: state.activationCode,
        month: state.month,
      };
      setState((prev) => ({
        ...prev,
        loader: true,
      }));
      service.fundTransfer(formData).then((res) => {
        if (res.status) {
          setState((prev) => ({
            ...prev,
            activationCode: "",
            month: "",
            securityCode: "",
            FormError,
            validated: !valid,
            IsError: true,
            notifyMessage: t("ewallet.fundTransferSuccessfully"),
            notyfiType: "success",
            header: t("Common.success"),
            loader: false,
          }));
          submitSuccess();
        } else {
          let error = "";
          switch (res.error.code) {
            case 1015:
              FormError.Password = t("validation.invalid", {
                field: "transactionPassword",
              });
              error = t("validation.invalid", { field: "transactionPassword" });
              break;
            case 406:
              error = "Not Acceptable";
              break;
            case 1072:
              error = t("validation.cannotTransfersameuser");
              break;
            case 1004:
              Object.keys(res.error.fields).map((key) => {
                if (key.substr(key.length - 4) !== "_err") {
                  error = res.error.fields[key];
                  switch (key) {
                    case "pswd":
                      FormError.Password = error;
                      break;
                    case "to_user_name":
                      FormError.toUsername = error;
                      break;
                    case "amount":
                      FormError.Amount = error;
                      break;
                    case "transaction_note":
                      FormError.Notes = error;
                      break;
                    default:
                      valid = true;
                      break;
                  }
                }
                return null;
              });
              break;
            default:
              break;
          }
          setState((prev) => ({
            ...prev,
            FormError,
            validated: true,
            IsError: true,
            notifyMessage: error,
            notyfiType: t("Common.error"),
            header: t("Common.error"),
            loader: false,
          }));
        }
      });
    } else {
      setState((prev) => ({
        ...prev,
        FormError,
        validated: !valid,
        IsError: true,
        notyfiType: t("Common.error"),
        header: t("Common.error"),
        loader: false,
      }));
    }
  };

  // Form validation
  const validation = (name) => {
    const values = state;
    let valid = true;
    let error = "";
    switch (name) {
      case "activationCode":
        if (!values.activationCode || values.activationCode.trim() === "") {
          error = "Please enter activation code";
          valid = false;
        }
        break;
      case "securityCode":
        if (!values.securityCode || values.securityCode.trim() === "") {
          error = "Please enter security code";
          valid = false;
        }
        break;
      case "month":
        if (!values.month || values.month.trim() === "") {
          error = "Please select a month";
          valid = false;
        }
        break;
      default:
        valid = true;
    }
    setState((prev) => ({
      ...prev,
      FormError: {
        ...prev.FormError,
        [name]: error,
      },
      validated: !valid,
    }));
    return valid;
  };

  useEffect(() => {
    const currentMonth = getCurrentMonth();
    setCurrentMonth(currentMonth);
    setState((prev) => ({
      ...prev,
      month: currentMonth,
    }));
  }, []);

  return (
    <Form onSubmit={submitForm} noValidate>
      <FormInputControl
        label={t("codeActivation.activationCode")}
        isRequired={true}
        error={{
          error: FormError.activationCode,
        }}
        inputProps={{
          name: "activationCode",
          onChange: textChangeHandler,
          value: state.activationCode,
        }}
      />
      <FormInputControl
        label={t("codeActivation.securityCode")}
        isRequired={true}
        error={{
          error: FormError.securityCode,
        }}
        inputProps={{
          name: "securityCode",
          onChange: textChangeHandler,
          value: state.securityCode,
        }}
      />
      {/* <FormSelectControl
        label={t("Month")}
        isRequired={true}
        error={{
          error: FormError.month,
        }}
        options={[
          { label: t("select month "), value: "" },
          { value: "01", label: t("January") },
          { value: "02", label: t("February") },
          { value: "03", label: t("March") },
          { value: "04", label: t("April") },
          { value: "05", label: t("May") },
          { value: "06", label: t("June") },
          { value: "07", label: t("July") },
          { value: "08", label: t("August") },
          { value: "09", label: t("September") },
          { value: "10", label: t("October") },
          { value: "11", label: t("November") },
          { value: "12", label: t("December") },
        ]}
        selectProp={{
          name: "month",
          onChange: textChangeHandler,
          value: state.month, // Use state.month for controlled component
        }}
      /> */}

<Form.Control
    as="input"
    type="text"
    value={state.month}
    disabled
  />  
      <Button
        type="submit"
        className={`btn-theme btn-theme-outline btn-block mb-3 ${style.button}`}
        disabled={state.loader}
      >
        {state.loader ? (
          <span
            className="spinner-border spinner-border-sm mr-2"
            role="status"
            aria-hidden="true"
          ></span>
        ) : (
          t("Button.processActivation")
        )}
      </Button>

      {IsError && (
        <AlertMessage
          message={notifyMessage}
          dismiss={notifyDissmissed}
          type={notyfiType}
          header={header}
          show={IsError}
        />
      )}
    </Form>
  );
}

export default ModalForms;
